import { useCallback, useEffect, useRef } from 'react';
import { getWindow } from '@/shared/lib/getWindow';

const TIMEOUT_MS = 10_000;

interface UsePayboxLogErrorProps {
    isPayboxEnabled: boolean;
    isPayboxReady: boolean;
    isPayboxResized: boolean;
}

interface LogErrorParams {
    isTimeout?: boolean;
    isIframeLoadError?: boolean;
}

export const usePayboxLogError = (props: UsePayboxLogErrorProps) => {
    const { isPayboxEnabled, isPayboxReady, isPayboxResized } = props;

    const isTimeoutLoggedRef = useRef(false);

    const logWidgetError = useCallback(
        (params: LogErrorParams) => {
            const window = getWindow();

            if (!window) {
                return;
            }

            if (window.Ya && window.Ya.Rum && window.Ya.Rum.logError) {
                const { isTimeout = false, isIframeLoadError = false } = params;

                window.Ya.Rum.logError({
                    message: 'Yandex Pay Widget Error',
                    level: 'critical',
                    additional: {
                        isPayboxReady,
                        isPayboxResized,
                        isTimeout,
                        isIframeLoadError,
                    },
                });
            }
        },
        [isPayboxReady, isPayboxResized]
    );

    useEffect(() => {
        if (!isPayboxEnabled || (isPayboxReady && isPayboxResized)) {
            return;
        }

        const timeoutId = setTimeout(() => {
            if (!isTimeoutLoggedRef.current && (!isPayboxReady || !isPayboxResized)) {
                isTimeoutLoggedRef.current = true;
                logWidgetError({ isTimeout: true });
            }
        }, TIMEOUT_MS);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [isPayboxEnabled, isPayboxReady, isPayboxResized, logWidgetError]);

    return { logWidgetError };
};
